"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityHeldCoverNote = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity");
const held_cover_note_document_map_entity_1 = require("./held-cover-note-document-map.entity");
let OpportunityHeldCoverNote = class OpportunityHeldCoverNote {
    constructor(opportunityId, activityId, opportunityActivityId, statusLid, placementSlipDeviationsLid, deviations, deviationsAddressedLid, resolutionLid, revisedHeldCoverNoteLid, acknowledgedBy, receiptNo, receiptDate, allDocumentsReceivedDate, remarks, createdBy, updatedBy, createdAt, updatedAt) {
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.opportunityActivityId = opportunityActivityId;
        this.statusLid = statusLid;
        this.placementSlipDeviationsLid = placementSlipDeviationsLid;
        this.deviations = deviations;
        this.deviationsAddressedLid = deviationsAddressedLid;
        this.resolutionLid = resolutionLid;
        this.revisedHeldCoverNoteLid = revisedHeldCoverNoteLid;
        this.acknowledgedBy = acknowledgedBy;
        this.receiptNo = receiptNo;
        this.receiptDate = receiptDate;
        this.allDocumentsReceivedDate = allDocumentsReceivedDate;
        this.remarks = remarks;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
};
exports.OpportunityHeldCoverNote = OpportunityHeldCoverNote;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "placement_slip_deviations_lid",
        type: "int",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "placementSlipDeviationsLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "deviations",
        type: "varchar",
        length: 500,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityHeldCoverNote.prototype, "deviations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "deviations_addressed_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "deviationsAddressedLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "revised_held_cover_note_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "revisedHeldCoverNoteLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "resolution_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "resolutionLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "acknowledged_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "acknowledgedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "receipt_no", type: "varchar", length: 255, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityHeldCoverNote.prototype, "receiptNo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "receipt_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], OpportunityHeldCoverNote.prototype, "receiptDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "all_documents_received_date",
        type: "date",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OpportunityHeldCoverNote.prototype, "allDocumentsReceivedDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", length: 1000, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityHeldCoverNote.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityHeldCoverNote.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], OpportunityHeldCoverNote.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], OpportunityHeldCoverNote.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "SET NULL",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _j : Object)
], OpportunityHeldCoverNote.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({
        name: "placement_slip_deviations_lid",
        referencedColumnName: "id",
    }),
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], OpportunityHeldCoverNote.prototype, "placementSlipDeviations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "deviations_addressed_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_l = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _l : Object)
], OpportunityHeldCoverNote.prototype, "deviationsAddressed", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({
        name: "revised_held_cover_note_lid",
        referencedColumnName: "id",
    }),
    tslib_1.__metadata("design:type", typeof (_m = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _m : Object)
], OpportunityHeldCoverNote.prototype, "revisedHeldCoverNote", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({
        name: "resolution_lid",
        referencedColumnName: "id",
    }),
    tslib_1.__metadata("design:type", typeof (_o = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _o : Object)
], OpportunityHeldCoverNote.prototype, "resolution", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({
        name: "status_lid",
        referencedColumnName: "id",
    }),
    tslib_1.__metadata("design:type", typeof (_p = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _p : Object)
], OpportunityHeldCoverNote.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => held_cover_note_document_map_entity_1.HeldCoverNoteDocumentMap, (documentMap) => documentMap.heldCoverNote, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityHeldCoverNote.prototype, "documents", void 0);
exports.OpportunityHeldCoverNote = OpportunityHeldCoverNote = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_held_cover_note"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, String, Number, Number, Number, Number, String, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, String, Number, Number, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object])
], OpportunityHeldCoverNote);
